// @ts-nocheck
import _ from 'lodash';
import React, { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { makeStyles, Box } from '@material-ui/core';
import { useAlert } from '../../../common/hooks';
import { AlertSeverity } from '../../../common/providers';
import { EmptyState, Panel } from '../../../common/components';
import { selectPendingActions } from '../../../common/state/pending';
import { selectCustomerDetails } from '../../customers/state/customerSelectors';
import { clearTracers } from '../state/tracerActions';
import TracerList from './partials/TracerList';

const useStyles = makeStyles(() => ({
  container: {
    height: '100%',
    minHeight: '500px',
  },
}));

function TracersPage() {
  const [t] = useTranslation();
  const { userId } = useParams();
  const { showAlert } = useAlert();
  const classes = useStyles();
  const pendingActions = useSelector(selectPendingActions);
  const customerDetails = useSelector(selectCustomerDetails);
  const [tracers, setTracers] = useState(_.defaultTo(customerDetails?.tracers, []));
  const dispatch = useDispatch();

  const handleClearTracers = useCallback(
    async selectedTracers => {
      try {
        await dispatch(clearTracers(userId, selectedTracers));
        setTracers(tracers.filter(tracer => !selectedTracers.includes(tracer)));
        showAlert({
          title: t('common.success'),
          message: t('tracer.tracersClearSuccess'),
          severity: AlertSeverity.Success,
        });
      } catch (e) {
        showAlert({
          title: t('tracer.tracersClearError'),
          message: e.message,
          severity: AlertSeverity.Error,
        });
      }
    },
    [dispatch, showAlert, t, userId]
  );

  return (
    <Box id="Tracers-container" className={classes.container}>
      <Panel id="Tracers-panel" variant="contained">
        {!customerDetails?.tracers ? (
          <EmptyState variant="unavailable" message={t('tracer.tracersNotAvailable')} />
        ) : (
          <TracerList
            data={tracers}
            onClearTracers={handleClearTracers}
            actionsDisabled={!_.isEmpty(pendingActions)}
          />
        )}
      </Panel>
    </Box>
  );
}

export default TracersPage;
